import apiClient from "../common/apiClient";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import OrderFormStep from "../common/OrderFormStep";
import FormTitle from "../components/formTitle/FormTitle";
import MuiRadio from "../components/radio/MuiRadio";
import MuiCheckbox from "../components/checkbox/MuiCheckbox";
import InputTextField from "../components/textField/InputTextField";
import MuiDatePicker from "../components/datePicker/MuiDatePicker";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import ClearOrder from "../components/modal/ClearOrder";
import "react-datepicker/dist/react-datepicker.css";
import TextField from '@material-ui/core/TextField';
import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

export default class KneeBundleLinerSelection extends OrderFormStep {
  constructor(props) {
    super(props);


    this.state = {
      isSubmit: false,
      linerInterfaces: [],
      linerSizes: [],
      linerProfiles: [],
      linerOptionCombinations: [],
      linerSuspensions: [],
      addLinerOptions: [],
      formState: {
        addLiner: new FieldState(true, 289),
        linerSuspension: new FieldState(true),
        linerInterface: new FieldState(true),
        linerSize: new FieldState(true),
        linerProfile: new FieldState(true),
        secondLinerSuspension: new FieldState(true),
        secondLinerInterface: new FieldState(true),
        secondLinerSize: new FieldState(true),
        secondLinerProfile: new FieldState(true),
        linerQuantity: new FieldState(true, 1),
      },
    };
  }

  getSuspensionText(suspensionId) {
    return this.state.linerSuspensions.filter(c => c.id === suspensionId)[0]?.displayName;
  }

  loadCart() {
    let cart = [];

    let currentSuspension = this.getSuspensionText(this.state.formState.linerSuspension.value);
    let currentInterface = this.state.formState.linerInterface.value;
    let currentProfile = this.state.formState.linerProfile.value;
    let currentSize = this.state.formState.linerSize.value;
    let partnumber = this.state.linerOptionCombinations.filter(
      c => c.interfaceId === currentInterface 
      && c.profileId === currentProfile 
      && c.sizeId === currentSize
      && c.suspension === currentSuspension
    )[0]?.partNumber;   

    let currentSuspension2 = this.getSuspensionText(this.state.formState.secondLinerSuspension.value);
    let currentInterface2 = this.state.formState.secondLinerInterface.value;
    let currentProfile2 = this.state.formState.secondLinerProfile.value;
    let currentSize2 = this.state.formState.secondLinerSize.value;
    let partnumber2 = this.state.linerOptionCombinations.filter(
      c => c.interfaceId === currentInterface2
      && c.profileId === currentProfile2 
      && c.sizeId === currentSize2
      && c.suspension === currentSuspension2
    )[0]?.partNumber;   


    if(partnumber) {
      cart.push({
        name: "First Liner",
        partNumber: partnumber,
        quantity: 1,
        price: -1
      });
    }

    if(partnumber2) {
      cart.push({
        name: "Second Liner",
        partNumber: partnumber2,
        quantity: 1,
        price: -1
      });
    }

    let config = {};
    config.params = {
      cart: cart.map(x => x.partNumber)
    }

    return apiClient.get("kneebundleprice/" + this.props.formTypeId,
      config
    ).then(response => {
      let data = response.data

      cart = cart.map(c => {
        return {
          name: c.name,
          partNumber: c.partNumber,
          quantity: c.quantity,
          price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
          sourceId: c.sourceId
        }
      });

      cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
        return {
          name: d.name,
          partNumber: d.partNumber,
          quantity: d.quantity,
          price: d.price,
          sourceId: d.sourceId
        }
      }));
      
      this.props.setTempCart(cart);
    }).catch(error =>{
      console.log(error)
    });
  }

  isRequired() {
    return true;
  }

  updateRequirements() {
    var formState = this.state.formState;
    var required = this.isRequired();

    formState.linerInterface.isRequired = required;
    formState.linerSize.isRequired = required;
    formState.linerProfile.isRequired = required;
    formState.linerQuantity.isRequired = required;

    this.setState({
      formState: formState
    });
  }

  onInputChange(e, id) {
    let formState = this.state.formState;
    formState.linerQuantity.value = e.target.value;
    this.setState({
      formState: formState,
      hasDataChanged: true,
    });
    this.loadCart();
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
      this.setState({
        linerSuspensions: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "linerSuspension" },
            }
          )
        ).data,
        linerInterfaces: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "linerInterface" },
            }
          )
        ).data,
        linerSizes: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "linerSize" },
            }
          )
        ).data,
        linerProfiles: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "linerProfile" },
            }
          )
        ).data,
        addLinerOptions: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "includeLiner" },
            }
          )
        ).data,
      });

      this.setState({
        linerOptionCombinations: (
          await apiClient.get("liners/" + this.props.formTypeId,
            {
            }
          )
        ).data
      });

      let config = {
        params: {
          fieldNames: [
            "linerSuspension",
            "linerInterface",
            "secondLinerInterface",
            "linerProfile",
            "secondLinerSuspension",
            "secondLinerProfile",
            "linerSize",
            "secondLinerSize",
            "includeLiner",
            "linerQuantity",
          ],
        },
      };

      const { data } = await apiClient.get("fieldInputs/" + this.props.formTypeId,
        config
      );
      let formState = this.state.formState;
      formState.linerSuspension.value = data.find(
        (fi) => fi.fieldName === "linerSuspension"
      )?.fieldOptionId;

      formState.linerSize.value = data.find(
        (fi) => fi.fieldName === "linerSize"
      )?.fieldOptionId;

      formState.linerProfile.value = data.find(
        (fi) => fi.fieldName === "linerProfile"
      )?.fieldOptionId;

      formState.linerInterface.value = data.find(
        (fi) => fi.fieldName === "linerInterface"
      )?.fieldOptionId;

      formState.secondLinerSuspension.value = data.find(
        (fi) => fi.fieldName === "secondLinerSuspension"
      )?.fieldOptionId;

      formState.secondLinerSize.value = data.find(
        (fi) => fi.fieldName === "secondLinerSize"
      )?.fieldOptionId;

      formState.secondLinerProfile.value = data.find(
        (fi) => fi.fieldName === "secondLinerProfile"
      )?.fieldOptionId;

      formState.secondLinerInterface.value = data.find(
        (fi) => fi.fieldName === "secondLinerInterface"
      )?.fieldOptionId;

      this.setState({
        formState: formState,
      });

      this.loadCart();
    

    this.setState({ isLoaded: true });
  }

  saveData() {

    let data = [];

    data.push({
      fieldName: "includeLiner",
      fieldOptionId: this.state.formState.addLiner.value,
    });

    if(this.isRequired()) {
      data.push({
        fieldName: "linerSuspension",
        fieldOptionId: this.state.formState.linerSuspension.value,
      });

      data.push({
        fieldName: "linerSize",
        fieldOptionId: this.state.formState.linerSize.value,
      });

      data.push({
        fieldName: "linerInterface",
        fieldOptionId: this.state.formState.linerInterface.value,
      });

      data.push({
        fieldName: "linerProfile",
        fieldOptionId: this.state.formState.linerProfile.value,
      });

      data.push({
        fieldName: "secondLinerSuspension",
        fieldOptionId: this.state.formState.secondLinerSuspension.value,
      });

      data.push({
        fieldName: "secondLinerSize",
        fieldOptionId: this.state.formState.secondLinerSize.value,
      });

      data.push({
        fieldName: "secondLinerInterface",
        fieldOptionId: this.state.formState.secondLinerInterface.value,
      });

      data.push({
        fieldName: "secondLinerProfile",
        fieldOptionId: this.state.formState.secondLinerProfile.value,
      });

      data.push({
        fieldName: "linerQuantity",
        numericData: this.state.formState.linerQuantity.value,
      });
    }

    if (this.validateData().isValid) {
      return apiClient.post("fieldInputs/" + this.props.formTypeId,
        data
      );
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");

      return;
    }
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    let validSuspensions = this.state.linerSuspensions;
    let currentSuspension = this.getSuspensionText(this.state.formState.linerSuspension.value);

    let validInterfaces = this.state.linerInterfaces.filter(i => 
      this.state.linerOptionCombinations.some(c => c.interfaceId === i.id 
                                                && c.suspension === currentSuspension)
    );
    let currentInterface = this.state.formState.linerInterface.value;

    let validProfiles = this.state.linerProfiles.filter(p =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === currentInterface 
                                                && c.profileId === p.id 
                                                && c.suspension === currentSuspension)
    );
    let currentProfile = this.state.formState.linerProfile.value;

    let validSizes = this.state.linerSizes.filter(s =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === currentInterface 
                                                && c.profileId === currentProfile 
                                                && c.sizeId === s.id
                                                && c.suspension === currentSuspension)
    );
    let currentSize = this.state.formState.linerSize.value;

    let partnumber = this.state.linerOptionCombinations.filter(
      c => c.interfaceId === currentInterface 
      && c.profileId === currentProfile 
      && c.sizeId === currentSize
      && c.suspension === currentSuspension
    )[0]?.partNumber;

    
    let currentSuspension2 = this.getSuspensionText(this.state.formState.secondLinerSuspension.value);
    let currentInterface2 = this.state.formState.secondLinerInterface.value;
    let validProfiles2 = this.state.linerProfiles.filter(p =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === currentInterface2 
                                                && c.profileId === p.id
                                                && c.suspension === currentSuspension2)
    );

    let currentProfile2 = this.state.formState.secondLinerProfile.value;
    let validSizes2 = this.state.linerSizes.filter(s =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === currentInterface2 
                                                && c.profileId === currentProfile2 
                                                && c.sizeId === s.id
                                                && c.suspension === currentSuspension2)
    );

    let currentSize2 = this.state.formState.secondLinerSize.value;
    let partnumber2 = this.state.linerOptionCombinations.filter(
      c => c.interfaceId === currentInterface2 
      && c.profileId === currentProfile2 
      && c.sizeId === currentSize2
      && c.suspension === currentSuspension2
    )[0]?.partNumber;
    


    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Product Information"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>

            {this.isRequired() && 
            <>
              <div className="msgBox fieldBorder msgBoxWidth">
                <h4 className="headLable"><b>First Liner:</b></h4>
              </div>
              <div className="fieldBorder">
                <MuiRadio
                  options={validSuspensions}
                  defaultValue={this.state.formState.linerSuspension.value}
                  label="Suspension"
                  required={this.state.formState["linerSuspension"].isRequired}
                  error={this.handleError("linerSuspension") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "linerSuspension");
                  }}
                />
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={validInterfaces}
                  defaultValue={currentInterface}
                  label="Interface"
                  required={this.state.formState["linerInterface"].isRequired}
                  error={this.handleError("linerInterface") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "linerInterface");
                  }}
                />
              </div>
              
              <div className="fieldBorder">
                <MuiRadio
                  options={validProfiles}
                  defaultValue={currentProfile}
                  label="Profile"
                  required={this.state.formState["linerProfile"].isRequired}
                  error={this.handleError("linerProfile") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "linerProfile");
                  }}
                />
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={validSizes}
                  defaultValue={currentSize}
                  label="Size"
                  required={this.state.formState["linerSize"].isRequired}
                  error={this.handleError("linerSize") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "linerSize");
                  }}
                />
              </div>

              <div className="msgBox fieldBorder msgBoxWidth">
                <h4 className="headLable"><b>Selected Liner:</b> {partnumber}</h4>
              </div>
            </>}

            {this.isRequired() && 
            <>
            <br/>
              <div className="msgBox fieldBorder msgBoxWidth">
                <h4 className="headLable"><b>Second Liner:</b></h4>
              </div>
              <div className="fieldBorder">
                <MuiRadio
                  options={validSuspensions}
                  defaultValue={this.state.formState.secondLinerSuspension.value}
                  label="Suspension"
                  required={this.state.formState["secondLinerSuspension"].isRequired}
                  error={this.handleError("secondLinerSuspension") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "secondLinerSuspension");
                  }}
                />
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={validInterfaces}
                  defaultValue={currentInterface2}
                  label="Interface"
                  required={this.state.formState["secondLinerInterface"].isRequired}
                  error={this.handleError("secondLinerInterface") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "secondLinerInterface");
                  }}
                />
              </div>
              
              <div className="fieldBorder">
                <MuiRadio
                  options={validProfiles2}
                  defaultValue={currentProfile2}
                  label="Profile"
                  required={this.state.formState["secondLinerProfile"].isRequired}
                  error={this.handleError("secondLinerProfile") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "secondLinerProfile");
                  }}
                />
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={validSizes2}
                  defaultValue={currentSize2}
                  label="Size"
                  required={this.state.formState["secondLinerSize"].isRequired}
                  error={this.handleError("secondLinerSize") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "secondLinerSize");
                  }}
                />
              </div>

              <div className="msgBox fieldBorder msgBoxWidth">
                <h4 className="headLable"><b>Selected Liner:</b> {partnumber2}</h4>
              </div>
            </>}

          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text = "Clear the Order?"
            onClick = {this.props.handleClickClearOpen}
          />           
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext(3);
                    this.setState({ isLoading: false });
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId = {this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
        />           
      </>
    );
  }
}